import { useState } from "react";
import { Facebook } from "lucide-react";
import { auth } from "../lib/api";

export default function Landing() {
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    setLoading(true);
    try {
      const { url } = await auth.loginUrl();
      window.location.href = url;
    } catch (e) {
      console.error(e);
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-6 bg-white"
      data-testid="landing-page"
    >
      <div className="w-full max-w-md text-center">
        <div className="w-14 h-14 bg-[#FF4F00] rounded-2xl mx-auto mb-8 flex items-center justify-center">
          <span className="font-display font-black text-white text-2xl">V</span>
        </div>
        <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-zinc-500 mb-3">
          Vouchzone · Facebook Connect
        </div>
        <h1
          className="font-display font-black tracking-tighter text-4xl sm:text-5xl mb-4 text-zinc-900"
          data-testid="hero-heading"
        >
          Connect to <span className="text-[#FF4F00]">Facebook</span>
        </h1>
        <p className="text-zinc-500 mb-10 leading-relaxed">
          Sign in to load your profile, posts, likes, photos and friends.
        </p>
        <button
          onClick={handleLogin}
          disabled={loading}
          className="btn-accent w-full justify-center"
          data-testid="fb-login-btn"
        >
          <Facebook className="w-5 h-5" strokeWidth={2.5} />
          {loading ? "Redirecting…" : "Continue with Facebook"}
        </button>
        <div className="mt-8 text-xs text-zinc-400 font-mono tracking-[0.2em] uppercase">
          public_profile · email · user_friends · user_posts · user_likes
        </div>
      </div>
    </div>
  );
}
